export const AnalyticsEvents = {
	// E-commerce funnel
	PRODUCT_VIEW: "product_view",
	ADD_TO_CART: "add_to_cart",
	CART_VIEW: "cart_view",
	REMOVE_FROM_CART: "remove_from_cart",
	CHECKOUT_START: "checkout_start",
	PURCHASE: "purchase",

	// Blog engagement
	BLOG_POST_VIEW: "blog_post_view",
	BLOG_SCROLL_DEPTH: "blog_scroll_depth",

	// Auth
	LOGIN: "login",
	SIGNUP_START: "signup_start",

	// Social sharing
	SOCIAL_SHARE: "social_share",

	// Contact
	CONTACT_FORM_SUBMIT: "contact_form_submit",

	// Newsletter
	NEWSLETTER_SUBSCRIBE: "newsletter_subscribe",
	BLOG_NEWSLETTER_SUBSCRIBE: "blog_newsletter_subscribe",
} as const
